/**
 * net/backoff.ts — espera educada entre tentativas (PLAYER.md §5.2).
 *
 * A regra do produto: `min(2^n × 3s, 5 min) ± 20%`. O jitter (±20%) não é
 * enfeite: é o que impede 200 TVs de uma rede que caiu voltando TODAS no mesmo
 * segundo — que é exatamente o modo de falha que derruba o servidor que a gente
 * está tentando poupar.
 *
 * ponytail: `Math.random` puro. Trocar por um PRNG semeado é o upgrade quando
 * houver teste que exija backoff determinístico no relógio.
 *
 * NOTA: o `Clock`/`Sleeper` NÃO vivem aqui — moram em `net/clock.ts`. Ter duas
 * interfaces de tempo era exatamente o tipo de duplicata que faz o gateway
 * corrigir o relógio e o player usar outro, e o anúncio "sai às 22:00" depender
 * de qual dos dois o chamador importou.
 */

export const BACKOFF_BASE_SECONDS = 3;
export const BACKOFF_CEILING_SECONDS = 300;
export const BACKOFF_JITTER_RATIO = 0.2;

/** Teto de espera: 5 min (PLAYER.md §5.2, `3s → 6s → … → 300s`). */
export function backoffDelayMs(attempt: number, random: () => number = Math.random): number {
  const n = Number.isFinite(attempt) && attempt > 0 ? Math.floor(attempt) : 0;
  const raw = BACKOFF_BASE_SECONDS * Math.pow(2, n);
  const capped = Math.min(raw, BACKOFF_CEILING_SECONDS);
  // ±20% uniforme. `random()` em [0,1) ⇒ fator em [0.8, 1.2).
  const factor = 1 + BACKOFF_JITTER_RATIO * (random() * 2 - 1);
  return Math.max(0, Math.round(capped * factor * 1000));
}
